import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sid = match ? match[1] : null;
    if (!sid) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sid } });
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        if (data.user.role === "admin" || data.user.status === "approved") navigate("/dashboard");
        else navigate("/pending");
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF7EE]">
      <p className="font-heading text-3xl text-[#3D5844] animate-pulse">Opening your sanctuary…</p>
    </div>
  );
}
